import type { IxfAccountingV1AccountKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const ACCOUNTING_COA_ACCOUNT_BASE_PATH = getResolvedPath('/clearing/finance/accounting/account');

export const getAccountingCoaAccountPath: EntityPathBuilder<IxfAccountingV1AccountKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return ACCOUNTING_COA_ACCOUNT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.accountId) {
        return undefined;
      }

      return getResolvedPath(`${ACCOUNTING_COA_ACCOUNT_BASE_PATH}/$accountId`, context?.keys);
    }
  }
};
